import React, { useState, useEffect, useContext } from "react";
import TopBar from "../../components/TopBar";
import { SessionContext } from "../../components/SessionContext";
import supabase from "../../supabase";
import moment from "moment";
import { IoLogoWhatsapp } from "react-icons/io";
import { toast } from "react-toastify";
import { TbFileInvoice, TbPrinter, TbDeviceFloppy, TbTrash } from "react-icons/tb";
import { sendWhatsAppNotification } from "../../services/whatsappService";
//made by chesecake//

const getStoreBadge = (templateType) => {
  if (!templateType) return null;
  const isPerfumes = templateType.includes("Perfumes");
  const isPrepaid = templateType.includes("Prepaid");

  return (
    <div className="flex flex-col gap-1 items-start">
      <span className={`px-2.5 py-1 rounded text-xs font-bold uppercase tracking-wider ${isPerfumes
        ? "bg-amber-100 text-amber-800 border border-amber-200"
        : "bg-purple-100 text-purple-800 border border-purple-200"
        }`}>
        {isPerfumes ? "Taqwa Perfumes" : "Taqwa Fashion Store"}
      </span>
      <span className={`px-2 py-0.5 rounded text-[10px] font-extrabold uppercase tracking-widest ${isPrepaid
        ? "bg-emerald-100 text-emerald-800 border border-emerald-200"
        : "bg-rose-100 text-rose-800 border border-rose-200"
        }`}>
        {isPrepaid ? "Prepaid" : "COD"}
      </span>
    </div>
  );
};

const CreatedInvoices = () => {
  const { session } = useContext(SessionContext);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [editingTrackingIds, setEditingTrackingIds] = useState({});


  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from("manual_invoices")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) {
        toast.error("Failed to fetch invoices: " + error.message);
      } else {
        setInvoices(data || []);
      }
    } catch (err) {
      toast.error("Unexpected error fetching invoices.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const handleTrackingIdChange = (invoiceId, value) => {
    setEditingTrackingIds({
      ...editingTrackingIds,
      [invoiceId]: value,
    });
  };

  const handleSaveTrackingId = async (invoice, newTrackingId) => {
    try {
      const { error } = await supabase
        .from("manual_invoices")
        .update({ tracking_id: newTrackingId })
        .eq("id", invoice.id);

      if (error) {
        toast.error("Error updating Tracking ID: " + error.message);
      } else {
        toast.success("Tracking ID updated successfully!");
        // Update local invoices state
        setInvoices(
          invoices.map((inv) =>
            inv.id === invoice.id ? { ...inv, tracking_id: newTrackingId } : inv
          )
        );
        // Clean editing state for this invoice
        const updatedEditing = { ...editingTrackingIds };
        delete updatedEditing[invoice.id];
        setEditingTrackingIds(updatedEditing);
      }
    } catch (err) {
      toast.error("Unexpected error updating Tracking ID.");
    }
  };

  const generateInvoiceHTML = (invoice) => {
    const storeName = invoice.template_type.includes("Perfumes") ? "TAQWA PERFUMES" : "TAQWA FASHION STORE";
    const isPrepaid = invoice.template_type.includes("Prepaid");
    const dateStr = moment(invoice.created_at).format("DD-MM-YYYY");
    const timeStr = moment(invoice.created_at).format("HH:mm");

    if (!isPrepaid) {
      const productRowHtml = `
        <tr>
          <td>${invoice.product_name || 'Manual Order Item'} (1)</td>
          <td style="text-align: center;">${invoice.amount || 0}</td>
          <td style="text-align: center; border-right: none;">${invoice.amount || 0}</td>
        </tr>
      `;

      return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>${invoice.order_id}</title>
<link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;700;900&family=Roboto:wght@400;700;900&display=swap" rel="stylesheet">
<style>
  @page { size: 4in 6in; margin: 0.1in; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { width: 3.8in; height: 5.8in; }
  body { font-family: 'Roboto Condensed', 'Roboto', sans-serif; font-size: 10pt; color: #000; background: #fff; text-transform: uppercase; }
  .label-wrapper { width: 100%; height: 100%; border: 2px solid #000; display: flex; flex-direction: column; }
  .row { display: flex; width: 100%; border-bottom: 1.5px solid #000; overflow: hidden; }
  .row:last-child { border-bottom: none; }
  .row-header { flex: 1.0; }
  .row-pin { flex: 0.5; }
  .row-shipto { flex: 5.2; }
  .row-seller-date { flex: 1.8; } 
  .row-products { flex: 3.2; display: block; }
  .row-orderid { flex: 0.6; }
  .row-footer { flex: 0.5; }
  .store-name { font-size: 17pt; font-weight: 900; text-align: center; line-height: 1.2; width: 100%; }
  .header-full { width: 100%; display: flex; align-items: center; justify-content: center; padding: 6px 8px; }
  .pin-left { width: 50%; padding: 4px 8px; font-size: 10pt; font-weight: 900; border-right: 1.5px solid #000; display: flex; align-items: center; }
  .route-right { width: 50%; padding: 4px 8px; font-size: 10pt; font-weight: 900; display: flex; align-items: center; justify-content: flex-end; }
  .shipto-cell { width: 62%; padding: 4px 8px; border-right: 1.5px solid #000; display: flex; flex-direction: column; }
  .shipto-addr-heavy { font-size: 10.5pt; font-weight: 900; line-height: 1.3; margin-top: 2px; word-break: break-word; overflow-wrap: break-word; }
  .cod-cell { width: 38%; padding: 7px 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; background: #fff; }
  .cod-amount-title { font-weight: 900; font-size: 10pt; line-height: 1.1; margin-bottom: 4px; white-space: nowrap; }
  .shipto-name { font-size: 12pt; font-weight: 900; }
  .seller-cell { width: 65%; padding: 7px 9px; border-right: 1.5px solid #000; display: flex; flex-direction: column; justify-content: center; }
  .seller-addr-bold { font-size: 8.5pt; font-weight: 700; line-height: 1.4; }
  .product-table { width: 100%; border-collapse: collapse; }
  .product-table th, .product-table td { padding: 5px 7px; border-right: 1.5px solid #000; font-weight: 900; }
  .product-table th { font-size: 8pt; border-bottom: 1.5px solid #000; background: #ebebeb; text-align: left; }
  .product-table td { font-size: 9pt; border-bottom: 1px solid #ccc; }
  .order-id-text { font-size: 12pt; font-weight: 900; letter-spacing: 1px; text-align: center; }
  .footer-text { font-size: 14pt; font-weight: 900; letter-spacing: 1px; text-align: center; width: 100%; }
</style>
</head>
<body>
<div class="label-wrapper">
  <div class="row row-header">
    <div class="header-full">
      <div class="store-name">${storeName}</div>
    </div>
  </div>
  <div class="row row-pin">
    <div class="pin-left">PINCODE: ${invoice.zip}</div>
    <div class="route-right">COD / SPEEDPOST</div>
  </div>
  <div class="row row-shipto">
    <div class="shipto-cell">
      <div>
        <div style="font-size: 8pt; font-weight: 700; margin-bottom: 2px;">SHIP TO:</div>
        <div class="shipto-name">${invoice.name}</div>
        <div class="shipto-addr-heavy">
          ${invoice.address}<br>
          ${invoice.place ? invoice.place + '<br>' : ''}
          ${invoice.postoffice_name ? 'Postoffice Name: ' + invoice.postoffice_name + '<br>' : ''}
          ${invoice.city}, ${invoice.state}<br>
          PIN: ${invoice.zip}
        </div>
      </div>
      <div style="font-size: 13pt; font-weight: 900; margin-top: 4px; line-height: 1.2;">
        PH: ${invoice.phone}
      </div>
    </div>
    <div class="cod-cell">
      <div class="cod-amount-title">COD AMOUNT</div>
      <div style="font-size: 20pt; font-weight: 900; line-height: 1;">
        ${invoice.amount || 0}
      </div>
      <div style="border: 1.5px solid #000; padding: 2px 4px; margin-top: 6px; width: 100%;">
        <div style="font-size: 6.5pt; font-weight: 900; margin-bottom: -2px;">E-BILLER ID</div>
        <div style="font-size: 13pt; font-weight: 900; letter-spacing: 1px;">${invoice.ebiller_id}</div>
      </div>
    </div>
  </div>
  <div class="row row-seller-date">
    <div class="seller-cell">
      <div style="font-size: 8pt; font-weight: 700; margin-bottom: 2px;">SELLER:</div>
      <div class="shipto-name" style="font-size: 9pt;">${storeName}</div>
      <div class="seller-addr-bold">
        PH: 7012556844<br>
        KANJIRAMATTOM, KERALA<br>
        INDIA 682315
      </div>
    </div>
    <div style="width: 35%; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
      <div style="font-size: 8pt; font-weight: 700;">ORDER DATE</div>
      <div style="font-size: 9pt; font-weight: 900;">
        ${dateStr}<br>
        ${timeStr}
      </div>
    </div>
  </div>
  <div class="row row-products">
    <table class="product-table">
      <thead>
        <tr>
          <th style="width: 58%;">PRODUCT (QTY)</th>
          <th style="width: 21%; text-align: center;">PRICE</th>
          <th style="width: 21%; text-align: center; border-right: none;">TOTAL</th>
        </tr>
      </thead>
      <tbody>
        ${productRowHtml}
        <tr style="background: #ebebeb;">
          <td style="border-top: 1.5px solid #000;">TOTAL</td>
          <td colspan="2" style="text-align: center; border-top: 1.5px solid #000; border-right: none; font-size: 10pt;">
            INR ${invoice.amount || 0}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row row-orderid" style="display:flex; align-items:center; justify-content:center; flex-direction:column; padding: 4px 0;">
    <div class="order-id-text">ORDER ID ${invoice.order_id}</div>
    ${invoice.tracking_id ? `<div style="font-size: 10pt; font-weight: 900; margin-top: 2px;">TRACKING ID: ${invoice.tracking_id}</div>` : ''}
  </div>
  <div class="row row-footer" style="display:flex; align-items:center; justify-content:center; border-bottom: none;">
    <div class="footer-text">THANK YOU FOR SHOPPING</div>
  </div>
</div>
</body>
</html>`;
    } else {
      const productRowHtml = `
      <tr>
        <td>${invoice.product_name || 'Manual Order Item'} (1)</td>
        <td style="text-align: center; border-right: none;">${invoice.amount || 0}</td>
      </tr>
    `;

      return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<title>${invoice.order_id}</title>
<link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@400;700;900&family=Roboto:wght@400;700;900&display=swap" rel="stylesheet">
<style>
  @page { size: 4in 6in; margin: 0.1in; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { width: 3.8in; height: 5.8in; }
  body { font-family: 'Roboto Condensed', 'Roboto', sans-serif; font-size: 10pt; color: #000; background: #fff; text-transform: uppercase; }
  .label-wrapper { width: 100%; height: 100%; border: 2px solid #000; display: flex; flex-direction: column; }
  .row { display: flex; width: 100%; border-bottom: 1.5px solid #000; overflow: hidden; }
  .row:last-child { border-bottom: none; }
  .row-header { flex: 1.0; }
  .row-pin { flex: 0.5; }
  .row-shipto { flex: 5.4; }
  .row-seller-date { flex: 1.8; } 
  .row-products { flex: 2.7; display: block; }
  .row-orderid { flex: 0.6; } 
  .row-footer { flex: 0.6; }
  .store-name { font-size: 17pt; font-weight: 900; text-align: center; line-height: 1.2; width: 100%; }
  .header-full { width: 100%; display: flex; align-items: center; justify-content: center; padding: 6px 8px; }
  .pin-left { width: 50%; padding: 4px 8px; font-size: 10pt; font-weight: 900; border-right: 1.5px solid #000; display: flex; align-items: center; }
  .type-right { width: 50%; padding: 4px 8px; font-size: 10pt; font-weight: 900; display: flex; align-items: center; justify-content: flex-end; }
  .shipto-cell { width: 72%; padding: 4px 8px; border-right: 1.5px solid #000; display: flex; flex-direction: column; }
  .shipto-addr-heavy { font-size: 10.5pt; font-weight: 900; line-height: 1.3; margin-top: 2px; word-break: break-word; overflow-wrap: break-word; }
  .prepaid-cell { width: 28%; padding: 5px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; background: #f2f2f2; }
  .ebiller-box-inner { border: 1.5px solid #000; padding: 5px 2px; width: 100%; }
  .ebiller-id { font-size: 13pt; font-weight: 900; letter-spacing: 1px; line-height: 1.1; }
  .paid-text-ultra { font-weight: 900; font-size: 28pt; letter-spacing: 2px; line-height: 1; margin-top: 8px; }
  .order-subtext { font-weight: 400; font-size: 9.5pt; letter-spacing: 1.5px; margin-top: 4px; }
  .seller-cell { width: 65%; padding: 7px 9px; border-right: 1.5px solid #000; display: flex; flex-direction: column; justify-content: center; }
  .seller-addr-bold { font-size: 9pt; font-weight: 900; line-height: 1.4; }
  .product-table { width: 100%; border-collapse: collapse; }
  .product-table th, .product-table td { border-right: 1.5px solid #000; padding: 5px 7px; font-weight: 900; }
  .product-table th { font-size: 8pt; background: #ebebeb; border-bottom: 1.5px solid #000; text-align: left; }
  .product-table td { font-size: 9pt; border-bottom: 1px solid #ccc; }
  .order-id-box { width: 100%; display: flex; align-items: center; justify-content: center; background: #fff; padding: 4px; }
  .order-id-text { font-size: 12pt; font-weight: 900; letter-spacing: 1px; }
  .footer-text { font-size: 16pt; font-weight: 900; letter-spacing: 1px; text-align: center; width: 100%; line-height: 1; }
</style>
</head>
<body>
<div class="label-wrapper">
  <div class="row row-header">
    <div class="header-full">
      <div class="store-name">${storeName}</div>
    </div>
  </div>
  <div class="row row-pin">
    <div class="pin-left">PINCODE: ${invoice.zip}</div>
    <div class="type-right">PREPAID / SPEEDPOST</div>
  </div>
  <div class="row row-shipto">
    <div class="shipto-cell">
      <div>
        <div style="font-size: 9pt; font-weight: 900; margin-bottom: 2px;">SHIP TO:</div>
        <div style="font-size: 12pt; font-weight: 900;">${invoice.name}</div>
        <div class="shipto-addr-heavy">
          ${invoice.address}<br>
          ${invoice.place ? invoice.place + '<br>' : ''}
          ${invoice.postoffice_name ? 'Postoffice Name: ' + invoice.postoffice_name + '<br>' : ''}
          ${invoice.city}, ${invoice.state}<br>
          PIN: ${invoice.zip}
        </div>
      </div>
      <div style="font-size: 13pt; font-weight: 900; margin-top: 4px; line-height: 1.2;">
        PH: ${invoice.phone}
      </div>
    </div>
    <div class="prepaid-cell">
      <div class="ebiller-box-inner">
        <div style="font-size: 8pt; font-weight: 900;">E-BILLER ID</div>
        <div class="ebiller-id">${invoice.ebiller_id}</div>
      </div>
      <div class="paid-text-ultra">PAID</div>
      <div class="order-subtext">ORDER</div>
    </div>
  </div>
  <div class="row row-seller-date">
    <div class="seller-cell">
      <div style="font-size: 9pt; font-weight: 900; margin-bottom: 2px;">SELLER:</div>
      <div class="seller-addr-bold">
        ${storeName}<br>
        PH: 7012556844<br>
        KANJIRAMATTOM P O ERNAKULAM<br>
        KERALA 682315
      </div>
    </div>
    <div style="width: 35%; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
      <div style="font-size: 8pt; font-weight: 900;">ORDER DATE</div>
      <div style="font-size: 10pt; font-weight: 900;">
        ${dateStr}<br>
        ${timeStr}
      </div>
    </div>
  </div>
  <div class="row row-products">
    <table class="product-table">
      <thead>
        <tr>
          <th style="width: 65%;">ITEM (QTY)</th>
          <th style="width: 35%; text-align: center; border-right: none;">PRICE</th>
        </tr>
      </thead>
      <tbody>
        ${productRowHtml}
        <tr style="background: #ebebeb;">
          <td style="border-top: 1.5px solid #000; font-size: 11pt;">TOTAL</td>
          <td style="text-align: center; border-top: 1.5px solid #000; border-right: none; font-size: 11pt;">
            ${invoice.amount || 0}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row row-orderid">
    <div class="order-id-box" style="flex-direction: column; padding: 4px 0;">
      <div class="order-id-text">ORDER ID ${invoice.order_id}</div>
      ${invoice.tracking_id ? `<div style="font-size: 10pt; font-weight: 900; margin-top: 2px;">TRACKING ID: ${invoice.tracking_id}</div>` : ''}
    </div>
  </div>
  <div class="row row-footer" style="display:flex; align-items:center; justify-content:center; border-bottom: none;">
    <div class="footer-text">THANK YOU FOR SHOPPING</div>
  </div>
</div>
</body>
</html>`;
    }
  };

  const handlePrint = (invoice) => {
    let printWindow = window.open("", "_blank");
    const html = generateInvoiceHTML(invoice);
    printWindow.document.write(html);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };

  const handleSendWhatsApp = async (invoice) => {
    // Determine the current tracking ID to use
    // Prioritize the edited text in editingTrackingIds state, or fallback to database tracking_id
    const currentTrackingId =
      editingTrackingIds[invoice.id] !== undefined
        ? editingTrackingIds[invoice.id]
        : invoice.tracking_id;

    if (!currentTrackingId || !String(currentTrackingId).trim()) {
      toast.warning("Please enter a Tracking ID before sending to WhatsApp!");
      return;
    }

    const trimmedTrackingId = String(currentTrackingId).trim();

    // If they have typed a new tracking ID but haven't saved it to DB yet, save it first!
    if (editingTrackingIds[invoice.id] !== undefined && editingTrackingIds[invoice.id] !== invoice.tracking_id) {
      toast.info("Saving Tracking ID first...");
      await handleSaveTrackingId(invoice, trimmedTrackingId);
    }

    const wpNumber = invoice.whatsapp || invoice.phone;
    if (!wpNumber) {
      toast.error("Please enter a Phone or WhatsApp number first!");
      return;
    }

    toast.info("Uploading invoice HTML...");

    let invoiceUrl = "";
    try {
      // Use the updated invoice data to generate HTML
      const updatedInvoiceData = { ...invoice, tracking_id: trimmedTrackingId };
      const htmlContent = generateInvoiceHTML(updatedInvoiceData);
      const blob = new Blob([htmlContent], { type: "text/html" });
      const filename = `invoices/invoice-${invoice.order_id}.html`;

      const { data: uploadData, error: uploadError } = await supabase.storage
        .from("banners")
        .upload(filename, blob, {
          contentType: "text/html",
          upsert: true,
        });

      if (!uploadError) {
        const { data: publicUrlData } = supabase.storage
          .from("banners")
          .getPublicUrl(filename);
        invoiceUrl = publicUrlData.publicUrl;
      } else {
        console.error("Error uploading invoice HTML:", uploadError);
      }
    } catch (err) {
      console.error("Unexpected error uploading invoice:", err);
    }

    const isPerfumes = invoice.template_type?.includes("Perfumes");
    const templateName = isPerfumes ? "taqwa_perfumes" : "taqwa_fashion_store";

    await sendWhatsAppNotification({
      to: wpNumber,
      customerName: invoice.name || "Customer",
      trackingId: trimmedTrackingId,
      templateName,
    });
  };

  const handleDeleteInvoice = async (invoice) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete manual invoice #${invoice.order_id} for ${invoice.name}?`);
    if (!confirmDelete) return;

    try {
      const { error } = await supabase
        .from("manual_invoices")
        .delete()
        .eq("id", invoice.id);

      if (error) {
        toast.error("Failed to delete invoice: " + error.message);
      } else {
        toast.success("Invoice deleted successfully!");
        setInvoices(invoices.filter((inv) => inv.id !== invoice.id));
      }
    } catch (err) {
      toast.error("An unexpected error occurred while deleting.");
    }
  };

  const filteredInvoices = invoices.filter((invoice) => {
    const searchLower = searchTerm.toLowerCase();
    const isPerfumes = invoice.template_type && invoice.template_type.includes("Perfumes");
    const storeName = isPerfumes ? "taqwa perfumes" : "taqwa fashion store";
    return (
      invoice.order_id?.toString().toLowerCase().includes(searchLower) ||
      invoice.name?.toLowerCase().includes(searchLower) ||
      invoice.phone?.toLowerCase().includes(searchLower) ||
      invoice.product_name?.toLowerCase().includes(searchLower) ||
      storeName.includes(searchLower)
    );
  });

  return (
    <>
      <TopBar avatarInfo={session?.user?.user_metadata} />
      <div className="page h-screen overflow-y-scroll p-8 bg-gray-100 pb-40">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          <h1 className="text-2xl font-bold text-blue-600 flex items-center gap-2">
            <TbFileInvoice size={28} />
            Created Manual Invoices
          </h1>
        </div>

        {/* Search Bar */}
        <div className="bg-white p-4 rounded shadow mb-6 max-w-4xl">
          <input
            type="text"
            placeholder="Search by Order ID, Customer Name, Phone, or Product Name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Invoices List */}
        <div className="bg-white rounded shadow overflow-hidden max-w-7xl">
          {loading ? (
            <div className="p-8 text-center text-gray-500 font-semibold">Loading invoices...</div>
          ) : filteredInvoices.length === 0 ? (
            <div className="p-8 text-center text-gray-500 font-semibold">No created invoices found.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-gray-800 text-white text-sm uppercase">
                    <th className="p-4">Order ID</th>
                    <th className="p-4">Store & Type</th>
                    <th className="p-4">Date</th>
                    <th className="p-4">Customer Info</th>
                    <th className="p-4">Product Details</th>
                    <th className="p-4">Amount</th>
                    <th className="p-4 w-64">Tracking ID</th>
                    <th className="p-4 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredInvoices.map((invoice) => {
                    const typedVal = editingTrackingIds[invoice.id];
                    const isChanged = typedVal !== undefined && typedVal !== invoice.tracking_id;

                    return (
                      <tr key={invoice.id} className="hover:bg-gray-50 text-sm">
                        <td className="p-4 font-bold text-gray-900">#{invoice.order_id}</td>
                        <td className="p-4">
                          {getStoreBadge(invoice.template_type)}
                        </td>
                        <td className="p-4 text-gray-600">
                          {moment(invoice.created_at).format("DD MMM YYYY")}<br />
                          <span className="text-xs text-gray-400">
                            {moment(invoice.created_at).format("h:mm A")}
                          </span>
                        </td>
                        <td className="p-4">
                          <div className="font-semibold">{invoice.name}</div>
                          <div className="text-xs text-gray-500">Ph: {invoice.phone}</div>
                          <div className="text-xs text-gray-400">
                            {invoice.city}, {invoice.state}
                          </div>
                        </td>
                        <td className="p-4">
                          <div className="text-gray-700 font-medium">{invoice.product_name || "N/A"}</div>
                        </td>
                        <td className="p-4 font-bold text-green-600">₹{invoice.amount}</td>
                        <td className="p-4">
                          <div className="flex items-center gap-2">
                            <input
                              type="text"
                              value={typedVal !== undefined ? typedVal : invoice.tracking_id || ""}
                              placeholder="Enter Tracking ID"
                              onChange={(e) => handleTrackingIdChange(invoice.id, e.target.value)}
                              className="w-full px-2 py-1.5 border rounded bg-green-50 text-xs focus:ring-1 focus:ring-green-500 focus:outline-none"
                            />
                            {isChanged && (
                              <button
                                onClick={() => handleSaveTrackingId(invoice, typedVal)}
                                title="Save Tracking ID"
                                className="p-2 bg-green-600 text-white rounded hover:bg-green-700 shadow flex items-center justify-center transition-all scale-100 hover:scale-105"
                              >
                                <TbDeviceFloppy size={16} />
                              </button>
                            )}
                          </div>
                        </td>
                        <td className="p-4">
                          <div className="flex gap-2 justify-center">
                            <button
                              onClick={() => handlePrint(invoice)}
                              className="px-3 py-1.5 bg-blue-600 text-white font-bold rounded shadow hover:bg-blue-700 flex items-center gap-1.5 text-xs transition-colors"
                              title="Print Invoice"
                            >
                              <TbPrinter size={16} />
                              Print
                            </button>
                            <button
                              onClick={() => handleSendWhatsApp(invoice)}
                              className="px-3 py-1.5 bg-green-600 text-white font-bold rounded shadow hover:bg-green-700 flex items-center gap-1.5 text-xs transition-colors"
                              title="Send to WhatsApp"
                            >
                              <IoLogoWhatsapp size={16} />
                              WhatsApp
                            </button>
                            <button
                              onClick={() => handleDeleteInvoice(invoice)}
                              className="px-3 py-1.5 bg-red-600 text-white font-bold rounded shadow hover:bg-red-700 flex items-center gap-1.5 text-xs transition-colors"
                              title="Delete Invoice"
                            >
                              <TbTrash size={16} />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CreatedInvoices;
